var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 234 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    stroke: "#1D2023",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.601 178.7h-8.367a16.733 16.733 0 01-16.733-16.733v-41.834a8.367 8.367 0 00-8.367-8.366h-8.366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.316 69.934a4.184 4.184 0 100 8.367 4.184 4.184 0 000-8.367z",
    fill: "#1D2023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 128.5a125.5 125.5 0 10251 0 125.5 125.5 0 00-251 0v0z"
  }))));
}

export default SvgInfoWarning;